import React, {useState, useEffect, useCallback, useRef, useMemo} from "react"
// Internal Dependancy
import ComponentWrapper from "components/HOC/ComponentWrapper"
import {get, post} from "helpers/api"
import styled from "styled-components"
import {Button} from "@uprise/button"
import {text} from "@uprise/typography"
import {Card} from "@uprise/card"
import {spacing} from "@uprise/spacing"
import {Modal} from "@uprise/modal"
import {H4, H5, H6} from "@uprise/headings"
import toast, { Toaster } from 'react-hot-toast';


export const HeaderTableContent = styled.div`
	display: flex;
`

export const CustomButton = styled(Button)`
	margin-left: 50px;
	width: 100px;
	height: 43px;
`
const FormInputContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`
const TextInput = styled.input`
	margin-left: 10px;
	margin-bottom: 0px;
	width: 60%;
	font-size:14px;
	height:40px;
	border-radius:5px;
	border-width:.7px;
	padding-left:10px;
	padding-right:10px;
`
const FormLabel = styled.label``
const Checkbox = styled.input`
	margin: 0;
	padding: 0;
`
const FunctionContainer = styled.div`
	display: flex;
`
const FunctionTitleContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-itmes: center;
	width: 80%;
	margin-top: 50px;
`
const AllFunctionContainer = styled.div`
	display: flex;
	flex-direction: column;
`
const FunctionName = styled.h5`
	margin-top: 10px;
	margin-bottom: 5px;
	font-size: 16px;
`
const FunctionSubName = styled.h6`
	margin-top: 10px;
	margin-bottom: 5px;
	margin-left: 10px;
	font-weight: normal;
	font-size: 14px;
`
const CheckboxContainer = styled.div`
	margin-top: 10px;
	// margin-bottom: 5px;
`

const AddRole = ({history}) => {
	const [allModules, setAllModules] = useState([])
	const [roleName, setRoleName] = useState("")
	// const []

	const clearAllCheckboxes = data => {
		data.forEach(item => {
			item["view_checked"] = false
			item["all_checked"] = false
			item?.children?.length > 0 &&
				item.children.forEach(child => {
					child["view_checked"] = false
					child["all_checked"] = false
				})
		})
		setAllModules(data)
	}

	const getAllModules = async () => {
		const modules = await get("crmModules")
		if (modules?.message?.length > 0) {
			const data = modules.message
			setAllModules(data)
			clearAllCheckboxes(data)
		}
	}

	useEffect(() => {
		getAllModules()
	}, [])

	const onViewOnlyCheckChange = (parentId, childId) => {
		const data = allModules
		data.forEach(item => {
			if (parseInt(item.id) === parseInt(parentId)) {
				if (!childId) {
					item["view_checked"] = !item["view_checked"]
				}

				item?.children?.length > 0 &&
					item.children.forEach(child => {
						if (childId && parseInt(child.id) === parseInt(childId)) {
							child["view_checked"] = !child["view_checked"]
						} else if (!childId) {
							child["view_checked"] = item["view_checked"]
						}
					})
			}
		})
		setAllModules([...data])
	}

	const onAllCheckChange = (parentId, childId) => {
		const data = allModules
		data.forEach(item => {
			if (parseInt(item.id) === parseInt(parentId)) {
				if (!childId) {
					item["all_checked"] = !item["all_checked"]
					item["view_checked"] = item["all_checked"]
				}

				item?.children?.length > 0 &&
					item.children.forEach(child => {
						if (childId && parseInt(child.id) === parseInt(childId)) {
							child["all_checked"] = !child["all_checked"]
							child["view_checked"] = child["all_checked"]
						} else if (!childId) {
							child["all_checked"] = item["all_checked"]
							child["view_checked"] = item["view_checked"]
						}
					})
			}
		})
		setAllModules([...data])
	}

	const onSubmit = () => {
		if (!roleName) {
			toast.error("Please add valid role name")
			return
		}
		let isFunctionSelected =  false
		allModules.forEach(item=>{
			if(item.view_checked ||  item.all_checked) {
				isFunctionSelected = true
			}
			item?.children?.length > 0 && item?.children?.forEach(subItem => {
				if(subItem.view_checked || subItem.all_checked){
					isFunctionSelected = true
				}
			})
		})
		if(!isFunctionSelected){
			toast.error("Please add valid role functions")
			return
		}
		let data = []
		allModules.forEach(item => {
			if (item["view_checked"] || item["all_checked"]) {
				data.push({moduleId: item.id, accessType: item["all_checked"] ? "ALL" : "VIEW"})
				item?.children?.length > 0 &&
					item.children.forEach(child => {
						if (child["view_checked"] || child["all_checked"]) {
							data.push({moduleId: child.id, accessType: item["all_checked"] ? "ALL" : "VIEW"})
						}
					})
			}
		})
		post("role/addRole", {
			modules: data,
			roleName
		})
			.then(result => {
				if (result.code === "success") {
					toast(result.message)
					setRoleName("")
					clearAllCheckboxes(allModules)
					history.push("/roles")
				} else {
					toast.error("Error while adding role")
				}
			})
			.catch(error => {
				console.log(error)
				toast.error("Error while adding role")
			})
	}

	const renderFunctions = () => {
		return (
			<FunctionContainer>
				<FunctionTitleContainer>
					<AllFunctionContainer>
						<H4>Functions</H4>
						{allModules?.map((item, pIndex) => {
							return (
								<div key={pIndex}>
									<FunctionName>{item?.name}</FunctionName>
									{item?.children?.length > 0 &&
										item.children.map((child, childIndex) => {
											return <FunctionSubName key={childIndex}>{child?.name}</FunctionSubName>
										})}
								</div>
							)
						})}
					</AllFunctionContainer>
					<AllFunctionContainer
						style={{
							justifyContent: "center",
							alignItems: "center"
						}}>
						<H4>View Only</H4>
						{allModules?.map((item, pIndex) => {
							return (
								<div key={pIndex}>
									<CheckboxContainer>
										<Checkbox
											type='checkbox'
											value={item.id}
											onChange={e => onViewOnlyCheckChange(item.id, null)}
											checked={item.view_checked}
											disabled={item.all_checked}
										/>
									</CheckboxContainer>
									{item?.children?.length > 0 &&
										item.children.map((child, childIndex) => {
											return (
												<CheckboxContainer key={childIndex}>
													<Checkbox
														type='checkbox'
														value={child.id}
														onChange={e => onViewOnlyCheckChange(item.id, child.id)}
														checked={child.view_checked}
														disabled={child.all_checked}
													/>
												</CheckboxContainer>
											)
										})}
								</div>
							)
						})}
					</AllFunctionContainer>
					<AllFunctionContainer
						style={{
							justifyContent: "center",
							alignItems: "center"
						}}>
						<H4>All access</H4>
						{allModules?.map((item, pIndex) => {
							return (
								<div key={pIndex}>
									<CheckboxContainer>
										<Checkbox
											type='checkbox'
											value={item.id}
											onChange={e => onAllCheckChange(item.id, null)}
											checked={item.all_checked}
										/>
									</CheckboxContainer>
									{item?.children?.length > 0 &&
										item.children.map((child, childIndex) => {
											return (
												<CheckboxContainer key={childIndex}>
													<Checkbox
														type='checkbox'
														value={child.id}
														onChange={e => onAllCheckChange(item.id, child.id)}
														checked={child.all_checked}
													/>
												</CheckboxContainer>
											)
										})}
								</div>
							)
						})}
					</AllFunctionContainer>
				</FunctionTitleContainer>
			</FunctionContainer>
		)
	}

	return (
		<ComponentWrapper menuActiveIndex={17} subMenuActiveIndex={17} headerTitle='Add Role'>
			<Card padding={spacing.s10} backgroundColor='white'>
				<FormInputContainer>
					<FormLabel>Role Name</FormLabel>
					<TextInput type='text' value={roleName} onChange={e => setRoleName(e.target.value)} />
					<CustomButton title={"Save"} variant={"primary"} onClick={onSubmit} />
				</FormInputContainer>
				{renderFunctions()}
			</Card>
			<Toaster />
		</ComponentWrapper>
	)
}

export default AddRole
